import * as Immutable from "immutable";
import BaseMessageRecord from "../BaseMessageRecord";

/**
 * @class ScheduledCallbackMessageRecord
 * @augments BaseMessageRecord
 */
class ScheduledCallbackMessageRecord extends BaseMessageRecord({
  type: "scheduled_callback",

  /**
   * @memberof ScheduledCallbackMessageRecord#
   */
  closingMessage: "Thanks, we'll be in touch shortly!",
  dialogMessage: "Please choose a time from the options below",
  lineOfBusiness: "",
  productType: "",
  errorResponseId: "",
  unavailableResponseId: ""
}) {}

/**
 * Validation
 */

/**
 * @param {ScheduledCallbackMessageRecord} message
 * @returns {Immutable.List.<String>}
 */
ScheduledCallbackMessageRecord.getInvalidFields = (message) => {
  const invalidFields = new Set();

  if (!message.dialogMessage.length) {
    invalidFields.add("dialogMessage");
  }

  if (!message.unavailableResponseId.length) {
    invalidFields.add("unavailableResponseId");
  }

  if (!message.errorResponseId) {
    invalidFields.add("errorResponseId");
  }

  if (!message.closingMessage.length) {
    invalidFields.add("closingMessage");
  }

  return Immutable.List(invalidFields);
};

export default ScheduledCallbackMessageRecord;
